import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type CartCalculateErrorResponse } from '../types/apiErrorResponse'
import { type CampaignCalculateRequest } from '../types/apiRequest'
import { type CampaignCalculateResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useRequest } = createRequestHelper<FortuneApis['post']['campaignCalculate'], CampaignCalculateResponse, CampaignCalculateRequest, CartCalculateErrorResponse>({
  client: 'fortune',
  key: (params) => {
    const { campaign_code, order_items } = params || {}
    if (!campaign_code || !order_items) {
      console.warn('[useApiCampaignCalculate] campaign_code, order_items are required!')
      return null
    }
    if (order_items.some(order_item => !order_item.sku)) {
      console.warn('[useApiCampaignCalculate] sku is required in order_items')
      return null
    }
    // 這裡的 querystring 是用來做 cache key 的實際送值是在 fetcher 裡面
    return `/campaigns/${campaign_code}/calculate?${queryStringify(params || {})}`
  },
  fetcher: client => (url, params) => client.post(url, params),
})

export const useApiCampaignCalculate = useRequest
